import { getVeloConstant } from '../../react/shared/lib/veloConstants'
import { trackEvent } from './eventTracker'

function grantFullGtagConsent() {
  const gtag = (window as any).gtag

  if (!gtag) {
    return
  }

  gtag('consent', 'update', {
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    ad_storage: 'granted',
    analytics_storage: 'granted',
  })
}

export function initCookieConsent() {
  const modal = document.getElementById('cookie-consent-modal')
  const acceptAllButton = document.getElementById('accept-all-cookies')
  const acceptRequiredButton = document.getElementById('accept-required-cookies')
  const container = document.getElementById('cookie-consent-modal-container')
  const modalStart = document.getElementById('cookie-consent-modal-start')
  const modalEnd = document.getElementById('cookie-consent-modal-end')

  if (
    !acceptAllButton ||
    !acceptRequiredButton ||
    !container ||
    !modal ||
    !modalStart ||
    !modalEnd
  ) {
    return
  }

  function showModal() {
    if (!modal || !container) {
      return
    }

    modal.classList.remove('hidden')
    container.focus()
  }

  function removeModal() {
    window.removeEventListener('keydown', handleKeydown)
    modal?.removeEventListener('click', handleClickAway)
    acceptAllButton?.removeEventListener('click', handleAcceptAll)
    acceptRequiredButton?.removeEventListener('click', handleAcceptRequired)
    modal?.remove()
  }

  async function saveConsent(consentLevel: 'required' | 'full') {
    removeModal()

    try {
      const response = await fetch('/api/internal/cookie-consent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ consent_level: consentLevel }),
      })

      if (!response.ok) {
        console.error('Failed to save cookie consent:', response)
        throw new Error('Failed to save cookie consent')
      }
    } catch (error) {
      console.error('Failed to save cookie consent:', error)
    }
  }

  function injectFacebookPixel() {
    const isEnabled = getVeloConstant('enableFbAnalytics', false)

    if (!isEnabled) {
      return
    }

    if ((window as any).fbq) {
      return
    }

    // Dynamically inject Facebook Pixel script
    const script = document.createElement('script')
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1398865262245551');
      fbq('track', 'PageView');
    `
    document.head.appendChild(script)
  }

  function handleAcceptAll() {
    grantFullGtagConsent()
    saveConsent('full')
    injectFacebookPixel()
    trackEvent('cookies_accepted_all')
  }

  function handleAcceptRequired() {
    saveConsent('required')
    trackEvent('cookies_accepted_required')
  }

  function handleKeydown(event: KeyboardEvent) {
    if (
      !acceptAllButton ||
      !acceptRequiredButton ||
      !container ||
      !modal ||
      !modalStart ||
      !modalEnd
    ) {
      return
    }

    if (event.key === 'Escape') {
      event.preventDefault()
      removeModal()
      return
    }

    if (event.key !== 'Tab') {
      return
    }

    // If shift + tab on first focusable element, move to last
    if (event.shiftKey && document.activeElement === modalStart) {
      event.preventDefault()
      acceptAllButton.focus()
    }

    // If tab on last focusable element, move to first
    if (!event.shiftKey && document.activeElement === modalEnd) {
      event.preventDefault()
      modalStart.focus()
    }
  }

  function handleClickAway(event: MouseEvent) {
    if (!container || !modal) {
      return
    }

    if (container.contains(event.target as HTMLElement)) {
      return
    }

    modal.remove()
  }

  showModal()

  window.addEventListener('keydown', handleKeydown)
  modal.addEventListener('click', handleClickAway)
  acceptAllButton.addEventListener('click', handleAcceptAll)
  acceptRequiredButton.addEventListener('click', handleAcceptRequired)
}
